import { useTranslation } from 'react-i18next';

import noItems from '../../assets/img/no-items.svg';

import './style.scss';

const NoItems = ({ titleNoItems }) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <img src={noItems} alt="no-items" />

      <p>{t(titleNoItems)}</p>
    </div>
  );
};

export default NoItems;
